import * as React from 'react';

import { ILocalization } from 'bernie-l10n';
import { ViewMedium, Viewport, ViewSmall } from 'bernie-view';

import { UitkHeading } from 'uitk-react-text';
import { UitkStepIndicatorExperimental } from 'uitk-react-step-indicator-experimental';

export interface MitHeaderProps {
  l10n: ILocalization;
}
export const MitHeader: React.FunctionComponent<MitHeaderProps> = ({ l10n }) => (
  <React.Fragment>
    <MultiItemStepIndicator l10n={l10n} className="all-b-padding-three all-t-padding-four" />
    <div className="all-b-padding-four">
      <UitkHeading level={1} size={700}>
        <Viewport>
          <ViewSmall>{l10n.formatText('multiItem.stepIndicator.hotel')}</ViewSmall>
          <ViewMedium>{l10n.formatText('multiItem.hsrTitle.hc')}</ViewMedium>
        </Viewport>
      </UitkHeading>
    </div>
  </React.Fragment>
);

MitHeader.displayName = 'MitHeader';
export interface MultiItemStepIndicatorProps {
  l10n: ILocalization;
  className: string;
}
export const MultiItemStepIndicator: React.FunctionComponent<MultiItemStepIndicatorProps> = ({ l10n, className }) => (
  <div className={className}>
    <UitkStepIndicatorExperimental
      steps={[
        { text: l10n.formatText(`multiItem.stepIndicator.hotel`), icon: `lob_hotels` },
        { text: l10n.formatText(`multiItem.stepIndicator.room`), icon: `bed` },
        { text: l10n.formatText(`multiItem.stepIndicator.car`), icon: `lob_cars` }
      ]}
      currentStep={0}
    />
  </div>
);
MultiItemStepIndicator.displayName = 'MultiItemStepIndicator';
